export default "__VITE_ASSET__61f1faab__"